import * as React from "react";
import { forwardRef } from "react";
const SvgExclamation = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" ref={ref} {...props}><path fill="currentColor" d="M7.133 1a1 1 0 0 0-.992 1.124l.75 6A1 1 0 0 0 7.883 9h.234a1 1 0 0 0 .992-.876l.75-6A1 1 0 0 0 8.867 1H7.133zM8 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" /></svg>;
const ForwardRef = forwardRef(SvgExclamation);
export default ForwardRef;